<template>
    <div class="page__content">
        <div class="columns">
            <div class="column is-8">
                <h2 class="page__headline">{{ $t('cancellationTerms.headline') }}</h2>
                <p class="page__copy">
                    {{ $t('cancellationTerms.copy') }}
                </p>
            </div>
        </div>
        <div class="column is-12 column__padding-left-zero">
            <div v-for="(num, index) in policies" :key="num.id" class="persons__person">
                <cancellation-term v-model="policies[index]" @delTerms="openModal(index)"></cancellation-term>
            </div>
        </div>
        <div class="is-clearfix">
            <a class="button is-primary is-pulled-left" @click="addCancelTerms()">{{ $t('cancellationTerms.addPolicy') }}</a>
        </div>
        <div class="modal isActive" :class="{ 'is-active': modal.isActive }">
            <div class="modal-background" @click="closeModal()"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modal.title }}</p>
                    <button class="delete" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body" v-html="modal.content">
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <a class="button" @click="closeModal()">{{ $t('generic.cancel') }}</a>
                    <a class="button is-danger" @click="deleteCancelTerms()">
                            <span class="icon">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </span>
                        <span>{{ $t('generic.delete') }}</span>
                    </a>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import { cancellationTerm } from '../../components';
    import { Api } from '../../../api';
    import { EventBus, Tracking } from '../../../utils';
    export default {
        name: 'cancellation-terms',
        components: {
            cancellationTerm
        },

        beforeRouteEnter(to, from, next) {
            Api.bootstrap().then(function(response) {
                return Promise.all([response, Api.policies.fetchPolicies()]);
            }).then(function(response) {
                next((vm) => {
                    vm.policies = response[1].body;
                });
            });
        },
        data() {
            return {
                modal: {
                    isActive: false,
                    title: null,
                    content: null
                },
                policies: null,
            };
        },
        mounted() {
        },
        methods: {
            addCancelTerms() {
                let newPolicy = {
                    'name': '',
                    'result': [
                        {
                            'cancel_days': '1',
                            'booking_span': 'after booking',
                            'amount': '0',
                            'minimum_checkbox': false,
                            'minimum_amount': '',
                            'currency': '€'
                        },
                    ]
                };
                // Tracking.trackEvent('Policies', 'addPolicy', null, null);
                this.policies.push(newPolicy);
                // scroll to position of added element which in this case is end of page
                setTimeout(() => {
                    document.body.scrollTop = this.$el.scrollHeight;
                }, 0);
            },
            closeModal() {
                this.modal.isActive = false;
            },
            deleteCancelTerms() {
                Api.policies.deletePolicy(this.modal.policy)
                    .then((response) => {
                        if(Math.floor(response.status / 100) === 2) {
                            this.policies.splice(this.modal.index, 1);
                            Api.bootstrap(true);
                            EventBus.$emit(EventBus.UPDATE_CHECKS);
                            Tracking.trackEvent('Policies', 'delete', 'success', null);
                        } else {
                            console.error('delete failed', response);
                            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                                title: 'Die Person konnte nicht gelöscht werden',
                                body: response.body.message,
                                type: 'danger',
                                direction: 'Up',
                                duration: 5000,
                            });
                            Tracking.trackEvent('Policies', 'delete', 'failed', null);
                        }
                    }, (response) => {
                        console.log('delete failed', response);
                        Tracking.trackEvent('Policies', 'delete', 'failed', null);
                    });
                this.closeModal();
            },
            openModal(index) {
                if(!this.policies[index].id) {
                    this.policies.splice(index, 1);
                    Tracking.trackEvent('Policies', 'discardUnsaved', null, null);
                    return;
                }
                this.modal.title = this.$t('generic.warning');
                this.modal.content = this.$t('generic.modal.delete', { name: this.policies[index].name });
                this.modal.isActive = true;
                this.modal.policy = this.policies[index];
                this.modal.index = index;
            },
            deleteUnsavedPolicies() {
                for(let term in this.policies) {
                    if(!this.policies[term].id) {
                        this.policies.splice(term, 1);
                        Tracking.trackEvent('Policies', 'discardUnsavedOnLeave', null, null);
                    }
                }
            },
        },
        beforeDestroy() {
            this.deleteUnsavedPolicies();
        },
    };
</script>

<style lang="scss">
    @import 'cancellation-terms.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/cancellation-terms/cancellationTerms.vue